/* unplugin-vue-components disabled */import { render } from "./commands-shortcuts.vue?vue&type=template&id=2f4b4c44&scoped=true"
import script from "./commands-shortcuts.vue?vue&type=script&lang=js"
export * from "./commands-shortcuts.vue?vue&type=script&lang=js"

import "./commands-shortcuts.vue?vue&type=style&index=0&id=2f4b4c44&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4b4c44"],['__file',"src/components/chat-input-v2/commands-menu/commands-shortcuts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f4b4c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f4b4c44', __exports__)) {
    api.reload('2f4b4c44', __exports__)
  }
  
  module.hot.accept("./commands-shortcuts.vue?vue&type=template&id=2f4b4c44&scoped=true", () => {
    api.rerender('2f4b4c44', render)
  })

}


export default __exports__